import certsReducer from "./reducer"
import certsSaga from "./sagas"

const saga = {
  reducers: certsReducer,
  sagas: certsSaga
}

export default saga